import React, { useState, useEffect } from "react";
import { NavBarBrand } from "./nav-bar-brand";
import { NavBarButtons } from "./nav-bar-buttons";
import { NavBarTabs } from "./nav-bar-tabs";
import { MobileMenuToggleButton } from "./mobile-menu-toggle-button";
import "./nav-bar.css";

const MobileMenuState = {
  CLOSED: "closed",
  OPEN: "open",
};

const MobileMenuIcon = {
  CLOSE: "close",
  MENU: "menu",
};

export const NavBar = () => {
  const [mobileMenuState, setMobileMenuState] = useState(MobileMenuState.CLOSED);
  const [mobileMenuIcon, setMobileMenuIcon] = useState(MobileMenuIcon.MENU);

  const isMobileMenuOpen = mobileMenuState === MobileMenuState.OPEN;

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("mobile-scroll-lock");
    } else {
      document.body.classList.remove("mobile-scroll-lock");
    }
    return () => {
      document.body.classList.remove("mobile-scroll-lock");
    };
  }, [isMobileMenuOpen]);

  const closeMobileMenu = () => {
    setMobileMenuState(MobileMenuState.CLOSED);
    setMobileMenuIcon(MobileMenuIcon.MENU);
  };

  const openMobileMenu = () => {
    setMobileMenuState(MobileMenuState.OPEN);
    setMobileMenuIcon(MobileMenuIcon.CLOSE);
  };

  const toggleMobileMenu = () => {
    if (isMobileMenuOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  };

  const mobileMenuClasses = `nav-bar__menu ${isMobileMenuOpen ? 'nav-bar__menu--active' : ''}`;

  return (
    <div className="nav-bar__container">
      <nav className="nav-bar">
        <NavBarBrand handleClick={closeMobileMenu} />
        <div className="nav-bar__actions">
          <NavBarTabs />
          <NavBarButtons />
        </div>
        <MobileMenuToggleButton
          icon={mobileMenuIcon}
          handleClick={toggleMobileMenu}
        />
        <div className={mobileMenuClasses}>
          <NavBarTabs handleClick={closeMobileMenu} />
          <NavBarButtons handleClick={closeMobileMenu} />
        </div>
      </nav>
    </div>
  );
};
